import { render, staticRenderFns } from "./AudienceSettingsBaseInput.vue?vue&type=template&id=67856bb8"
import script from "./AudienceSettingsBaseInput.vue?vue&type=script&lang=ts"
export * from "./AudienceSettingsBaseInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports